import { isMobile } from 'react-device-detect';
import useMediaQuery from '@material-ui/core/useMediaQuery';

const useMobileLayout = () => useMediaQuery((theme) => theme.breakpoints.down(760)) && isMobile;

export default useMobileLayout;
